// extracted by mini-css-extract-plugin
module.exports = {"cart":"styles_cart__3XhTV","billingInfo":"styles_billingInfo__1nqXO","subtotal":"styles_subtotal__1RFjI","checkout":"styles_checkout__jR-c3"};